export const MessageInputKeys = {
  Enter: 'Enter',
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown',
  Backspace: 'Backspace',
};

export const NodeTypes = {
  ElementNode: 1,
  TextNode: 3,
};

export const NodeNames = {
  Span: 'SPAN',
  Br: 'BR',
  Div: 'DIV',
};
